/* eslint-disable no-unused-vars */
import { logoSymbol } from "@/assets";
import AnimatedPage from "@/components/AnimatedPage";
import HeaderBox from "@/components/HeaderBox";
import HelmetMetaData from "@/components/HelmetMetaData";
import NoHistory from "@/components/NoHistory";
import { Dialog, DialogContent } from "@/components/ui/dialog";

import { cn } from "@/lib/utils";
import moment from "moment";
import { useEffect, useState } from "react";
import { BsDownload } from "react-icons/bs";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { FcCancel } from "react-icons/fc";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import parse from "html-react-parser";
import { Badge } from "@/components/ui/badge";
import TransactionDialog from "./transactionDialog";

const Transactions = () => {
  const user = useSelector((state) => state.user.user);
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    if (user && user?.transactions?.length > 0) {
      setTransactions(user.transactions);
    }
  }, [user]);
  const formatter = new Intl.NumberFormat("en-US");
  const [currentTransaction, setCurrentTransaction] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <AnimatedPage>
      <HelmetMetaData
        title="Transaction History | Billzpay"
        description="Quickly purchase airtime for your mobile phone with our easy-to-use platform. Stay connected with instant top-ups and secure transactions!
"
      />

      <section className="p-3 sm:p-5">
        <div className="flex flex-col-reverse items-start justify-between md:flex-row">
          <HeaderBox
            title="Transaction History"
            subtext="See your recent transactions."
          />

          <div>
            <h2 className="text-sm font-medium">
              <Link to="/dashboard" className="hover:underline">
                Dashboard
              </Link>

              <span className="px-2 text-xl font-thin">/</span>

              <span className="text-gray-400">Transactions</span>
            </h2>
          </div>
        </div>

        <div>
          {/* trj */}
          <TransactionDialog
            currentTransaction={currentTransaction}
            setCurrentTransaction={setCurrentTransaction}
          />

          {/* {transactions} */}
          {transactions?.length === 0 ? (
            <NoHistory />
          ) : (
            <div className="flex flex-col gap-4 pt-3">
              {transactions?.map((transaction, index) => (
                <button
                  key={index}
                  className="flex cursor-pointer items-center justify-between text-start"
                  onClick={() => {
                    setCurrentTransaction(transaction);
                    setDialogOpen(true);
                  }}
                >
                  <div className="flex items-center justify-between gap-2">
                    <div
                      className={`rounded-full ${transaction.status == "Successful" ? "bg-green-500" : "bg-sky-500"} flex h-[50px] w-[50px] items-center justify-center`}
                    >
                      {transaction?.type === "Account Deposit" ? (
                        <BsDownload className="text-xl font-bold text-white" />
                      ) : transaction.type === "" ? (
                        <span className="text-xl font-semibold text-white">
                          AD
                        </span>
                      ) : (
                        <span className="text-xl font-semibold text-white">
                          {transaction.type[0]}
                        </span>
                      )}
                    </div>

                    <div>
                      <h1 className="text-[14px] font-medium text-black/85 dark:text-white">
                        {transaction?.type === ""
                          ? "Admin Funding"
                          : transaction?.type}
                      </h1>

                      <p className="dark:text-darkGray text-[12px] text-gray-600">
                        {moment(transaction?.created_at).format("MMM Do, h:mm:ssA")}
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col items-center">
                    <p className="text-[14px] font-medium lg:text-base lg:font-semibold dark:text-white">
                      {transaction?.type === "Account Deposit" && "+"}₦
                      {formatter.format(transaction?.amount)}
                    </p>
                    <Badge
                      className={cn(
                        "border-transparent text-[11px] text-white",
                        transaction.status?.toLowerCase()?.includes("suc")
                          ? "bg-green-600 focus-visible:ring-green-600/20 dark:bg-green-600/60 dark:focus-visible:ring-green-600/40 [a&]:hover:bg-green-600/90"
                          : "bg-destructive dark:bg-destructive/60 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 [a&]:hover:bg-destructive/90",
                      )}
                    >
                      {transaction.status}
                    </Badge>{" "}
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </section>
    </AnimatedPage>
  );
};

export default Transactions;
